/* global Office */
/* global Word */

import OfficeSettings from "@/constants/office";
import { OfficeEnvironment } from "@/types/document";
import log from "../../../utils/logger";

// @TODO: this is to be removed potentially
async function checkUniqueLocalIdSupport() {
  return true;
  // if is web, its always supported
  if (OfficeSettings.environment === OfficeEnvironment.Online) {
    return true;
  }

  const hasRequiredRequirementSet = Office.context.requirements.isSetSupported("WordApi", "1.6");
  if (!hasRequiredRequirementSet) {
    return false;
  }

  return Word.run(async (context) => {
    try {
      const { paragraphs } = context.document.body;
      paragraphs.load("uniqueLocalId");
      await context.sync();
      if (paragraphs.items.some((paragraph) => paragraph.uniqueLocalId == null)) {
        log.warn("word api requirement set 1.6 supported but found null paragraph ids");
        return false;
      }

      return true;
    } catch (error) {
      log.error("error checking for uniqueLocalId support", undefined, error);
      return false;
    }
  });
}

export default checkUniqueLocalIdSupport;
